import { FormFields } from "@/types";
import { $t } from "@/lib/helpers/i18nHelper";
import config from "@/config";

export const fields: FormFields = [
  {
    name: "email",
    title: $t("Email"),
    clearable: false,
  },
  {
    name: "password",
    title: $t("Password"),
    clearable: false,
    type: "password",
    browserAutocomplete: "new-password",
  },
  {
    name: "role",
    title: $t("Role"),
    type: "select",
    clearable: false,
    list: config.userRoleList.map(role => ({ value: role, text: $t(role) })),
  },
];
